import ReactMarkdown from 'react-markdown';
import '../../styles/EditCase.css';

export default function DiagnosisContent({ diagnosis, onCopy, copySuccess }) {
    if (!diagnosis) return null;

    return (
        <div>
            <div className="document-toolbar">
                <button
                    type="button"
                    className={`copy-button ${copySuccess ? 'copied' : ''}`}
                    onClick={onCopy}
                >
                    {copySuccess ? '\u2713 Copied!' : 'Copy to Clipboard'}
                </button>
            </div>
            <div className="results-container">
                <div className="results-answer">
                    <ReactMarkdown>{diagnosis}</ReactMarkdown>
                </div>
            </div>
        </div>
    );
}
